var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlberca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4001 11.2405H30.44",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75989 11.2395H19.5596",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.2395H2.91996",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5603 30.4393C7.08023 30.4393 7.08023 31.7193 10.6002 31.7193C14.1201 31.7193 14.1201 30.4393 17.64 30.4393",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1996 30.4393C23.3995 30.4393 23.3995 31.7193 26.5995 31.7193C29.7994 31.7193 29.7994 30.4393 32.9993 30.4393",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6403 32.9994V13.7998L26.842 2.29663C27.4986 1.47745 28.4919 1.00002 29.5415 1.00002H29.544C31.4525 1.00002 33 2.54751 33 4.45595V11.2398H30.44V4.41755C30.44 3.94396 30.056 3.55997 29.5824 3.55997H29.5799C29.3149 3.55997 29.0653 3.68284 28.9028 3.89148L20.2002 15.0797V32.9994H17.6403Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55995 22.7596V15.0797L12.2625 3.89148C12.4251 3.68284 12.6747 3.55997 12.9396 3.55997H12.9422C13.4158 3.55997 13.7998 3.94396 13.7998 4.41755V11.2398H16.3597V4.45595C16.3597 2.54751 14.8122 1.00002 12.9038 1.00002H12.9012C11.8516 1.00002 10.8584 1.47745 10.2017 2.29663L1 13.7998V32.9994H3.55995V25.3195",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6397 25.3196H2.27997C1.57343 25.3196 1 24.7462 1 24.0396C1 23.3331 1.57343 22.7596 2.27997 22.7596H17.6397",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlberca);
export default __webpack_public_path__ + "static/media/icon-alberca.b72f130d2d1558f24ebb9def3ec7624b.svg";
export { ForwardRef as ReactComponent };